"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTrackingStyle = exports.getEstimateStyle = exports.getDestinationConfig = exports.getDisqualifiedConfig = exports.getQuoteConfig = exports.parseErrors = exports.parseEstimatedLocation = void 0;
exports.isSmallMobile = isSmallMobile;
exports.applySmallMobileStyling = applySmallMobileStyling;
exports.deepClean = deepClean;
exports.nestedObjectAssign = nestedObjectAssign;
exports.deepClone = deepClone;
var parseEstimatedLocation = function (loc) {
    if (!loc) {
        return '';
    }
    if (!loc.estimated_country || !loc.estimated_city) {
        return "".concat(loc.postal_code, ", ").concat(loc.country);
    }
    var region = loc.estimated_country === 'US' && loc.estimated_region
        ? loc.estimated_region
        : '';
    var city = loc.estimated_city.toLowerCase();
    return region === ''
        ? "".concat(city, ", ").concat(loc.estimated_country)
        : "".concat(city, ", ").concat(region, ", ").concat(loc.estimated_country);
};
exports.parseEstimatedLocation = parseEstimatedLocation;
var parseErrors = function (errors) {
    var errorMessages = [];
    var keys = Object.keys(errors);
    if (keys.includes('destination')) {
        errorMessages.push('Invalid location details. Please check your destination address info and try again.');
    }
    else if (keys.includes('origin')) {
        errorMessages.push('Invalid location details. Please check your origin address info and try again.');
    }
    else {
        errorMessages.push('We have encountered an error.\nPlease try submitting the form again.');
    }
    return errorMessages;
};
exports.parseErrors = parseErrors;
var getQuoteConfig = function (config) {
    return __assign(__assign({}, config.text.quoted), { detailOriginLabel: config.text.detailOriginLabel, detailDestinationLabel: config.text.detailDestinationLabel, returnLinkLabel: config.text.returnLinkLabel });
};
exports.getQuoteConfig = getQuoteConfig;
var getDisqualifiedConfig = function (config) {
    return __assign(__assign({}, config.text.disqualified), { detailOriginLabel: config.text.detailOriginLabel, detailDestinationLabel: config.text.detailDestinationLabel, returnLinkLabel: config.text.returnLinkLabel });
};
exports.getDisqualifiedConfig = getDisqualifiedConfig;
var getDestinationConfig = function (config) {
    return __assign(__assign({}, config.text.destination), { detailOriginLabel: config.text.detailOriginLabel, background: config.style.color.background });
};
exports.getDestinationConfig = getDestinationConfig;
var getEstimateStyle = function (config) {
    return {
        '--background': config.style.color.background,
        '--text-primary': config.style.color.textPrimary,
        '--text-secondary': config.style.color.textSecondary,
        '--border': config.style.color.border,
        '--border-hover': config.style.color.borderHover,
        '--border-focused': config.style.color.borderFocused,
        '--button-background': config.style.color.buttonBackground,
        '--button-background-hover': config.style.color.buttonBackgroundHover,
        '--button-background-disabled': config.style.color.buttonBackgroundDisabled,
        '--button-text': config.style.color.buttonText,
        '--button-text-hover': config.style.color.buttonTextHover,
        '--button-text-disabled': config.style.color.buttonTextDisabled,
        '--quote-background': config.style.color.quoteBackground,
        '--error-text': config.style.color.errorText,
        '--error-background': config.style.color.errorBackground,
        '--font-family': config.style.fontFamily,
        '--font-size': "".concat(config.style.fontSize, "px"),
        '--width': "".concat(config.style.width, "px"),
        '--height': "".concat(config.style.height, "px"),
    };
};
exports.getEstimateStyle = getEstimateStyle;
var getTrackingStyle = function (config) {
    return {
        '--background': config.style.color.background,
        '--text-primary': config.style.color.textPrimary,
        '--text-secondary': config.style.color.textSecondary,
        '--border': config.style.color.border,
        '--font-family': config.style.fontFamily,
        '--font-size': "".concat(config.style.fontSize, "px"),
        '--width': config.style.variant === 'default' ? '540px' : '320px',
        '--default-styling': config.style.variant === 'default' ? 'flex' : 'none',
        '--minimal-styling': config.style.variant === 'default' ? 'none' : 'flex',
        '--location-direction': config.style.variant === 'default' ? 'row' : 'column',
        '--location-justify': config.style.variant === 'default' ? 'center' : 'flex-start',
        '--location-align': config.style.variant === 'default' ? 'flex-start' : 'center',
        '--location-flex': config.style.variant === 'default' ? '1 0 0' : '0 1 auto',
        '--backdrop-color': config.style.backdropColor,
        '--animationIn': getAnimationStyleIn(config.animation.in, config),
        '--button-background': config.style.color.buttonBackground,
        '--button-background-hover': config.style.color.buttonBackgroundHover,
        '--button-border': config.style.color.buttonBorder,
        '--button-text': config.style.color.buttonText,
        '--button-text-hover': config.style.color.buttonTextHover,
        '--button-border-hover': config.style.color.buttonBorderHover,
    };
};
exports.getTrackingStyle = getTrackingStyle;
var getAnimationStyleIn = function (animation, config) {
    var _a;
    if (animation.type === null) {
        return 'none';
    }
    var type = animation.type === 'fade'
        ? 'fadeInAnimation'
        : config.style.position === 'left'
            ? 'slideInFromLeft'
            : 'slideInFromRight';
    return "".concat(type, " ").concat((_a = animation.easing) !== null && _a !== void 0 ? _a : 'ease', " ").concat(animation.duration, "ms");
};
var MINIMUM_RENDERING_HEIGHT = 467;
function isSmallMobile() {
    return window.innerWidth <= 800 && window.innerHeight <= 600;
}
function applySmallMobileStyling(finalConfig) {
    if (isSmallMobile()) {
        finalConfig.style.position = 'center';
        finalConfig.style.width = window.screen.availWidth;
        finalConfig.style.height = Math.max(window.screen.availHeight, MINIMUM_RENDERING_HEIGHT);
    }
}
function deepClean(obj) {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }
    var cleanedObj = Object.entries(obj).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        if (value === null || value === undefined) {
            return acc;
        }
        if (typeof value === 'object' && !Array.isArray(value)) {
            var cleanedValue = deepClean(value);
            if (Object.keys(cleanedValue).length > 0) {
                acc[key] = cleanedValue;
            }
        }
        else {
            acc[key] = value;
        }
        return acc;
    }, {});
    return cleanedObj;
}
function nestedObjectAssign(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    sources.forEach(function (source) {
        if (source) {
            Object.keys(source).forEach(function (key) {
                var s_val = source[key];
                var t_val = target[key];
                target[key] =
                    t_val &&
                        s_val &&
                        typeof t_val === 'object' &&
                        typeof s_val === 'object'
                        ? nestedObjectAssign(t_val, s_val)
                        : s_val;
            });
        }
    });
    return target;
}
function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}
